import React, { createContext, useContext, ReactNode } from 'react';
import { featureFlags, FeatureFlags } from '../config/featureFlags';

// Create the context
const FeatureFlagContext = createContext<FeatureFlags>(featureFlags);

// Provider component
export const FeatureFlagProvider: React.FC<{
  children: ReactNode;
  flags?: Partial<FeatureFlags>;
}> = ({ children, flags = {} }) => {
  // Merge default flags with any overrides
  const mergedFlags = { ...featureFlags, ...flags };
  
  return (
    <FeatureFlagContext.Provider value={mergedFlags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

// Hook for consuming feature flags
export const useFeatureFlags = () => useContext(FeatureFlagContext);

// Utility hook for specific flags
export const useFeatureFlag = (flagName: keyof FeatureFlags) => {
  const flags = useFeatureFlags();
  return flags[flagName];
};
